import { useMemo } from 'react'
import { getTenantBrandingUrls } from '../utils/tenantBrandingUrls'

/**
 * useTenantLogoUrl Hook
 *
 * Returns the current tenant's logo URL — resolved server-side from the request's
 * `Host` header by `BaseTenantBrandingAssetsController`, never 404s (falls back
 * tenant-specific -> platform-default -> an embedded placeholder). No fetch/state is
 * needed today since the URL is deterministic and anonymous; exposed as a hook (rather
 * than a plain function call) for API consistency with the rest of this package, and so
 * a future version can add caching/preloading without changing call sites.
 *
 * @example
 * ```tsx
 * const logoSrc = useTenantLogoUrl(config.iamApiBaseUrl)
 * <LoginRedirectPage appName="My App" logoSrc={logoSrc} />
 * ```
 */
export function useTenantLogoUrl(apiBaseUrl: string): string {
  return useMemo(() => getTenantBrandingUrls(apiBaseUrl).logoUrl, [apiBaseUrl])
}

export default useTenantLogoUrl
